import gql from 'graphql-tag';

export const MSTI_TYPE = gql`
query mstiTypes($typeString: String) {
  mstiTypes (first: 100, typeString: $typeString){
    edges {
      node {
        id
        letter
        descriptions (first:10){
          edges {
            node {
              key
              description
            }
          }
        }
      }
    }
  }
}
`
